import { Box, BoxProps, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useMessageContext } from 'app/components/Chat/context';
import { getSimpleMessageSx } from './sxStyles';

interface SimpleMessageProps extends BoxProps {
  isCurrentUser?: boolean;
}

export const SimpleMessage: FC<SimpleMessageProps> = ({
  isCurrentUser,
  ...rest
}) => {
  const { message } = useMessageContext();
  const { text } = message;
  const { containerSx, textSx } = getSimpleMessageSx(isCurrentUser);

  return (
    <Box sx={containerSx} {...rest} role="group">
      <Text sx={textSx}>{text}</Text>
    </Box>
  );
};
